/**
 * Live-refreshes the homepage "My Queue" carousel whenever a bookmark is
 * toggled anywhere on the page (search results, featured video, related
 * videos, etc.) — so newly-queued or newly in-progress content shows up
 * immediately instead of requiring a page reload.
 *
 * Only does anything when the homepage's [data-queue-home-feed] container is
 * present in the DOM (it's always rendered for logged-in users, hidden via
 * the `hidden` class when there's nothing to show yet).
 */
async function refreshHomeFeed() {
  const container = document.querySelector('[data-queue-home-feed]');
  if (!container) return;

  try {
    const response = await fetch('/watch-queue/home-feed', {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
    });

    const data = await response.json();
    if (!data || !data.success) return;

    const content = container.querySelector('[data-queue-home-feed-content]');
    if (content) {
      content.innerHTML = data.html;
    }

    container.classList.toggle('hidden', !data.hasItems);

    document.dispatchEvent(new CustomEvent('queue:home-feed-updated'));
  } catch (error) {
    console.debug('Failed to refresh homepage queue feed:', error);
  }
}

document.addEventListener('queue:changed', refreshHomeFeed);

